module.exports = __webpack_public_path__ + "static/media/1.92e42bf5.PNG";